/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
var O;!function(O){O[O.Off=0]="Off",O[O.On=1]="On",O[O.COUNT=2]="COUNT"}(O||(O={}));export{O as PremultipliedAlphaSource};
